import * as React from 'react';
import { useHistory } from 'react-router';

import arrowBack from '../../assets/images/arrow-left-slider.svg';

interface IProps {

}

export const BackButton: React.SFC<IProps> = () => {
    const history = useHistory();

    return (
        <button onClick={() => history.goBack()}>
            <img
                style={{
                    width: '40px',
                    marginBottom: '40px',
                    cursor: 'pointer'
                }}
                alt=""
                src={arrowBack}
            />
        </button>
    );
};
